import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const integrationConnectionContract = c.router(
    {
        getConnections: {
            method: "GET",
            path: "/:workspaceId",
            responses: {
                200: c.type<{ connections: IntegrationConnectionDto[] }>(),
            },
        },
        fixConnection: {
            method: "PATCH",
            path: "/:workspaceId/:connectionId/fix",
            body: z.object({
                oAuthCode: z.string().optional(),
                customParams: z.any().optional(),
            }),
            responses: {
                204: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/integration-connection",
    },
);
